import { ICreateAlert } from '../../../../models/manager/account/accountModel';

interface Iaction {
  type:
    | 'alertName'
    | 'alertType'
    | 'alertPeriod'
    | 'appList'
    | 'country'
    | 'store'
    | 'alertEmail'
    | 'alertClass'
    | 'delAppList';
  state: {
    alertNameVal?: string;
    alertTypeVal?: string;
    alertPeirodVal?: string;
    appListVal?: any;
    countryVal?: string;
    storeVal?: string;
    alertEmailVal?: string;
    alertClassVal?: string;
  };
}

export const createObjReducer = (state: ICreateAlert, action: Iaction): ICreateAlert => {
  switch (action.type) {
    case 'alertName':
      return { ...state, alertName: action.state.alertNameVal };
    case 'alertType':
      return { ...state, alertType: action.state.alertTypeVal };
    case 'alertPeriod':
      return { ...state, alertPeirod: action.state.alertPeirodVal };
    case 'appList':
      const objIndex = state.appList.findIndex((appObj) => {
        return appObj.appId === action.state.appListVal.appId && appObj.appType === action.state.appListVal.appType;
      });
      if (objIndex === -1) {
        return { ...state, appList: state.appList.concat(action.state.appListVal) };
      } else {
        return {
          ...state,
          appList: state.appList.filter((item) =>
            item.appId === action.state.appListVal.appId && item.appType === action.state.appListVal.appType
              ? false
              : true
          ),
        };
      }
    case 'country':
      return { ...state, country: action.state.countryVal };
    case 'store':
      return { ...state, store: action.state.storeVal };
    case 'alertEmail':
      return { ...state, alertEmail: action.state.alertEmailVal };
    case 'alertClass':
      if (state.alertClass.includes(action.state.alertClassVal)) {
        return { ...state, alertClass: state.alertClass.filter((item) => item !== action.state.alertClassVal) };
      } else {
        return { ...state, alertClass: state.alertClass.concat(action.state.alertClassVal) };
      }
    case 'delAppList':
      return {
        ...state,
        appList: state.appList.filter((item) =>
          item.appId === action.state.appListVal.appId && item.appType === action.state.appListVal.appType
            ? false
            : true
        ),
      };
    default:
      return state;
  }
};
